export default __webpack_public_path__ + "static/media/twitter.8a1d7324.svg";